/**
 * Map grouped locations to locations list
 */
export function mapLocations(groupLocations) {
  const locations = groupLocations.map(item => item.location);
  const uniqueIds = new Set();
  const uniqueLocation = locations.filter(item => {
    if (!uniqueIds.has(item.id)) {
      uniqueIds.add(item.id);
      return item;
    }

    return null;
  }).filter(item => !!item);

  uniqueLocation.forEach(item => {
    item.connected = item.kiosks.some(kiosk => typeof kiosk.lastSync === 'string');
    item.power = item.kiosks.every(kiosk => kiosk.enabled);
    item.isExpanded = false;
  });

  return uniqueLocation;
}

export function getOperatorSpecificLocations(
  operatorAndAllLocationsData,
  operatorId
) {
  if (Number(operatorId) === 1) return operatorAndAllLocationsData;
  const locationDataByOperatorId = operatorAndAllLocationsData?.filter(
    (operatorAndLocationData) =>
      operatorAndLocationData.accountId === operatorId
  );
  return locationDataByOperatorId;
}